import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CheckboxFormFieldComponent} from '@aviary/forms/fields/checkbox-form-field/checkbox-form-field.component';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'px-sms-terms-checkbox',
  template: `
    <mx-checkbox-form-field [fieldName]="fieldName" [formGroup]="formGroup" overrideLabel="">
      <div class="flex-col gap-1">
        <p class="text-body-medium">
          I agree to receive automated SMS/text notifications from my library related to my library account and circulation activity. Message frequency varies.
          Message and data rates may apply. I can manage notification preferences in my account or contact library staff for help. See
          <a href="https://www.simplicity-ils.com/sms-notification-terms" target="_blank" rel="noopener">SMS Notification Terms</a> and
          <a href="https://www.simplicity-ils.com/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.
        </p>
        @if (!isTermsAcceptedValid) {
          <div class="flex flex-row gap-x-[0.161rem] w-full items-start text-label-small text-error">
            <mat-icon class="mat-icon-size-3.5 material-icons-outlined shrink-0">warning</mat-icon>
            <p>SMS consent is required to use SMS notifications. Check the box above to confirm consent, or select a different notification method.</p>
          </div>
        }
      </div>
    </mx-checkbox-form-field>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CheckboxFormFieldComponent, MatIcon]
})
export class SmsTermsCheckboxComponent {
  @Input() public formGroup: ExtendedFormGroup;
  @Input() public fieldName: string = 'smsTermsAccepted';
  @Input() public isTermsAcceptedValid: boolean;
}
